import { Component, FormEvent, ReactNode, createRef } from 'react'

import moment, { Moment } from 'moment'

import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'

import { UserType } from "../../libs/user/User"

import { NUMBER_PATTERN, isEmpty, isValid } from '../../libs/validation/stringRegex'

import MultipleCheckbox from "../../libs/ui/inputs/MultipleCheckbox"
import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'

import {
    DATE_FORMAT, DATE_PRINT_FORMAT, 
    isNotValidDataInzioViaggio, isNotValidDataFineViaggio
} from '../../libs/validation/dateValidation'

interface StepProps {
    tipo_viaggio: string | undefined
    destinazione: string | undefined
    data_inizio: string | undefined
    data_fine: string | undefined
    durata: string | undefined
    soggetti: string | undefined
    eta: number | undefined
    eta_assicurato_1: number | undefined
    eta_assicurato_2: number | undefined
    numero_figli: string | undefined
    numero_partecipanti: number | undefined
    eta_partecipanti: string | undefined
    tipo_copertura: string | undefined

    user: UserType | undefined

    noMotorPrivacy: any

    tipo_viaggioError: string | undefined
    destinazioneError: string | undefined
    data_inizioError: string | undefined
    data_fineError: string | undefined
    durataError: string | undefined
    soggettiError: string | undefined
    etaError: string | undefined
    eta_assicurato_1Error: string | undefined
    eta_assicurato_2Error: string | undefined
    numero_figliError: string | undefined
    numero_partecipantiError: string | undefined
    eta_partecipantiError: string | undefined
    tipo_coperturaError: string | undefined

    noMotorPrivacyError: string | undefined

    tipo_coperture: any
    tipo_destinazioni: any
    tipo_durate: any
    tipo_numero_figli: any
    tipo_persone: any
    tipo_viaggi: any

    updateTipo_viaggioCallBack: Function
    updateDestinazioneCallBack: Function
    updateData_inizioCallBack: Function
    updateData_fineCallBack: Function
    updateDurataCallBack: Function
    updateSoggettiCallBack: Function
    updateEtaCallBack: Function
    updateEta_assicurato_1CallBack: Function
    updateEta_assicurato_2CallBack: Function
    updateNumero_figliCallBack: Function
    updateNumero_partecipantiCallBack: Function
    updateEta_partecipantiCallBack: Function
    updateTipo_coperturaCallBack: Function

    updateNoMotorPrivacyCallBack: Function
}

interface StepState {
    data_fine_start: Moment
    data_fine_end: Moment
}

class TravelStep2 extends Component<StepProps, StepState> {
    private dataFineRef: React.RefObject<HTMLDivElement>

    constructor (props: any) {
        super (props)

        const NOW = new Date()
        const start = (this.props.data_inizio === undefined) 
            ? moment(NOW).add(1, 'day') 
            : moment(this.props.data_inizio, 'YYYY-MM-DD').add(1, 'day')
        const end = (this.props.data_inizio === undefined) 
            ? moment(NOW).add(1, 'months') 
            : moment(this.props.data_inizio, 'YYYY-MM-DD').add(1, 'months')

        this.state = {
            data_fine_start: start,
            data_fine_end: end,
        }

        this.validateInizioViaggio = this.validateInizioViaggio.bind(this)
        this.validateFineViaggio = this.validateFineViaggio.bind(this)
        this.validateMaggiorenne = this.validateMaggiorenne.bind(this)
        this.updateEtaPartecipanti = this.updateEtaPartecipanti.bind(this)

        this.updateDataFine = this.updateDataFine.bind(this)

        this.dataFineRef = createRef()
    }

    componentDidUpdate(prevProps: Readonly<StepProps>, prevState: Readonly<StepState>, snapshot?: any): void {
        if (
            prevProps.data_inizio !== this.props.data_inizio ||
            prevProps.data_fine !== this.props.data_fine
        ) {
            const NOW = new Date()

            const start = (this.props.data_inizio === undefined)
                ? moment(NOW).add(1, 'day')
                : moment(this.props.data_inizio, 'YYYY-MM-DD').add(1, 'day')

            const end = (this.props.data_inizio === undefined)
                ? moment(NOW).add(1, 'months') 
                : moment(this.props.data_inizio, 'YYYY-MM-DD').add(1, 'months')

            this.setState({
                data_fine_start: start,
                data_fine_end: end
            })
        }
    }

    render (): ReactNode {
        const NOW = new Date()

        const DATE_START = moment(NOW).add(1, 'day').format(DATE_FORMAT)
        const DATE_END = moment(NOW).add(1, 'months').format(DATE_FORMAT)

        const DATE_START_FORMATTED = moment(NOW).add(1, 'day').format(DATE_PRINT_FORMAT)
        const DATE_END_FORMATTED = moment(NOW).add(1, 'months').format(DATE_PRINT_FORMAT)

        const INIZIO_VIAGGIO_DISPLAY_ERROR = 'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
        const FINE_VIAGGIO_DISPLAY_ERROR = 'tra ' 
            + this.state.data_fine_start.format(DATE_PRINT_FORMAT) 
            + ' e ' 
            + this.state.data_fine_end.format(DATE_PRINT_FORMAT)

        const isSingoloViaggio = this.props.tipo_viaggio === 'viaggioSingolo'
        const isAnnualeViaggio = this.props.tipo_viaggio === 'polizzaAnnuale'

        const isSingolaPersona = this.props.soggetti === 'singolaPersona'
        const isCoppia = this.props.soggetti === 'coppia'
        const isGenitori = this.props.soggetti === 'genitoreConFigli'
        const isFamiglia = this.props.soggetti === 'famiglia'
        const isGruppo = this.props.soggetti === 'gruppo'

        const etaPartecipanti : any = {}

        if (isGruppo) {
            const partecipnati = this.props.eta_partecipanti?.split( ';' )

            for (let i = 0; i < (this.props.numero_partecipanti ?? 0); i++) {
                etaPartecipanti[ String( i ) ] = undefined
            }

            // sistemo i valori --> non posso avere + età del numero di partecipanti
            if (partecipnati) {
                partecipnati.length = this.props.numero_partecipanti ?? 0
            }

            partecipnati?.forEach ( x => {
                const tmp = x.split( ':' )

                etaPartecipanti[ tmp[0] ] = tmp[1]
            })
        }

        return (
            <>
                <div className="col-12">
                    <Select
                        id='tipo_viaggio' name='tipo_viaggio'
                        label='Per cosa richiedi il preventivo?' 
                        value={this.props.tipo_viaggio}
                        options={this.props.tipo_viaggi}
                        callback={this.props.updateTipo_viaggioCallBack}
                        error={this.props.tipo_viaggioError}
                    />

                    { isSingoloViaggio &&
                        <div className="row" key='date_viaggio'>
                            <div className="col-12 col-md-6" key='date_viaggio_inizio'>
                                <Input 
                                    label='Data inizio viaggio'
                                    id='data_inizio' name='data_inizio' key='data_inizio'
                                    type='date'
                                    value={this.props.data_inizio}
                                    min={DATE_START}
                                    max={DATE_END}
                                    callback={this.updateDataFine}
                                    errorDisplayMsg={INIZIO_VIAGGIO_DISPLAY_ERROR}
                                    regexp={this.validateInizioViaggio}
                                    error={this.props.data_inizioError}
                                />
                            </div>
                            <div className="col-12 col-md-6" key='date_viaggio_fine' ref={this.dataFineRef}>
                                <Input 
                                    label='Data fine viaggio'
                                    id='data_fine' name='data_fine' key='data_fine_end'
                                    type='date'
                                    value={this.props.data_fine}
                                    min={ this.state.data_fine_start.format(DATE_FORMAT) }
                                    max={ this.state.data_fine_end.format(DATE_FORMAT) }
                                    callback={this.props.updateData_fineCallBack}
                                    errorDisplayMsg={FINE_VIAGGIO_DISPLAY_ERROR}
                                    regexp={this.validateFineViaggio}
                                    error={this.props.data_fineError}
                                />
                            </div>
                        </div>
                    }
                    { isAnnualeViaggio &&
                        <Select
                            id='durata' name='durata'
                            label='Durata massima del tuo viaggio' 
                            value={this.props.durata}
                            options={this.props.tipo_durate}
                            callback={this.props.updateDurataCallBack}
                            error={this.props.durataError}
                        />
                    }

                    <Select
                        id='destinazione' name='destinazione'
                        label='Seleziona la tua destinazione' 
                        value={this.props.destinazione}
                        options={this.props.tipo_destinazioni}
                        callback={this.props.updateDestinazioneCallBack}
                        error={this.props.destinazioneError}
                    />

                    <Select
                        id='soggetti' name='soggetti'
                        label='Soggetti da assicurare' 
                        value={this.props.soggetti}
                        options={this.props.tipo_persone}
                        callback={this.props.updateSoggettiCallBack}
                        error={this.props.soggettiError}
                    />

                    { isSingolaPersona &&
                        <Input
                            id='eta' name='eta' key='eta'
                            type='number'
                            label='Età'
                            min='18'
                            max='99'
                            step='1'
                            value={this.props.eta?.toString()}
                            regexp={this.validateMaggiorenne}
                            callback={this.props.updateEtaCallBack}
                            errorDisplayMsg='Valore non valido'
                            error={this.props.etaError}
                        />
                    }

                    { isGenitori &&
                        <div className='row'>
                            <div className="col-12 col-md-6">
                                <Input
                                    id='eta' name='eta' key='eta'
                                    type='number'
                                    label='Età'
                                    min='18'
                                    max='99'
                                    step='1'
                                    value={this.props.eta?.toString()}
                                    regexp={this.validateMaggiorenne}
                                    callback={this.props.updateEtaCallBack}
                                    errorDisplayMsg='Valore non valido'
                                    error={this.props.etaError}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <Select
                                    id='numero_figli' name='numero_figli' key='numero_figli'
                                    label='Numero figli' 
                                    value={this.props.numero_figli}
                                    options={this.props.tipo_numero_figli}
                                    callback={this.props.updateNumero_figliCallBack}
                                    error={this.props.numero_figliError}
                                />
                            </div>
                        </div>
                    }

                    { isCoppia && 
                        <div className='row'>
                            <div className="col-12 col-md-6">
                                <Input
                                    id='eta_assicurato_1' name='eta_assicurato_1' key='eta_assicurato_1'
                                    type='number'
                                    label='Età assicurato 1'
                                    min='18'
                                    max='99'
                                    step='1'
                                    value={this.props.eta_assicurato_1?.toString()}
                                    regexp={this.validateMaggiorenne}
                                    callback={this.props.updateEta_assicurato_1CallBack}
                                    errorDisplayMsg='Valore non valido'
                                    error={this.props.eta_assicurato_1Error}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    id='eta_assicurato_2' name='eta_assicurato_2' key='eta_assicurato_2'
                                    type='number'
                                    label='Età assicurato 1'
                                    min='18'
                                    max='99'
                                    step='1'
                                    value={this.props.eta_assicurato_2?.toString()}
                                    regexp={this.validateMaggiorenne}
                                    callback={this.props.updateEta_assicurato_2CallBack}
                                    errorDisplayMsg='Valore non valido'
                                    error={this.props.eta_assicurato_2Error}
                                />
                            </div>
                        </div>
                    }

                    { isFamiglia && 
                        <div className='row'>
                            <div className="col-12 col-md-6">
                                <Input
                                    id='eta_assicurato_1' name='eta_assicurato_1' key='eta_assicurato_1'
                                    type='number'
                                    label='Età assicurato 1'
                                    min='18'
                                    max='99'
                                    step='1'
                                    value={this.props.eta_assicurato_1?.toString()}
                                    regexp={this.validateMaggiorenne}
                                    callback={this.props.updateEta_assicurato_1CallBack}
                                    errorDisplayMsg='Valore non valido'
                                    error={this.props.eta_assicurato_1Error}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <Input
                                    id='eta_assicurato_2' name='eta_assicurato_2' key='eta_assicurato_2'
                                    type='number'
                                    label='Età assicurato 1'
                                    min='18'
                                    max='99'
                                    step='1'
                                    value={this.props.eta_assicurato_2?.toString()}
                                    regexp={this.validateMaggiorenne}
                                    callback={this.props.updateEta_assicurato_2CallBack}
                                    errorDisplayMsg='Valore non valido'
                                    error={this.props.eta_assicurato_2Error}
                                />
                            </div>
                            <div className='col-12'>
                                <Select
                                    id='numero_figli' name='numero_figli' key='numero_figli'
                                    label='Numero figli' 
                                    value={this.props.numero_figli}
                                    options={this.props.tipo_numero_figli}
                                    callback={this.props.updateNumero_figliCallBack}
                                    error={this.props.numero_figliError}
                                />
                            </div>
                        </div>
                    }

                    { isGruppo &&
                        <>
                            <Input
                                id='numero_partecipanti' name='numero_partecipanti' key='numero_partecipanti'
                                type='number'
                                label='Numero partecipanti'
                                min='3'
                                max='9'
                                step='1'
                                onInput={
                                    (e: any) => {
                                        if (e.currentTarget?.value) {
                                            const valNumber = Number(e.currentTarget.value)

                                            if (valNumber < 3) e.currentTarget.value = 3
                                            if (valNumber > 9) e.currentTarget.value = 9
                                        }
                                    }
                                        
                                }
                                value={this.props.numero_partecipanti?.toString()}
                                regexp={NUMBER_PATTERN}
                                callback={this.props.updateNumero_partecipantiCallBack}
                                errorDisplayMsg='Valore non valido'
                                error={this.props.numero_partecipantiError}
                            />

                            {
                                Object.entries(etaPartecipanti).map (([i, ele]) => {
                                    const _id = i as string
                                    const _val = ele as string

                                    const sError = ( 
                                        this.props.eta_partecipantiError !== undefined &&
                                        (isEmpty( _val ) || !isValid( _val, NUMBER_PATTERN ))
                                    ) ? 'valore non valido' : undefined

                                    return (
                                        <Input
                                            id={ _id } name={ 'eta_partecipanti' + _id } 
                                            key={ 'eta_partecipanti' + _id } 
                                            type='number'
                                            label={ 'Età partecipante ' + (Number(_id) + 1) + '' }
                                            min='18'
                                            max='99'
                                            step='1'
                                            value={ _val }
                                            regexp={NUMBER_PATTERN}
                                            callback={this.updateEtaPartecipanti}
                                            errorDisplayMsg='Valore non valido'
                                            error={ sError }
                                            bubleEvent={true}
                                        />
                                    )
                                })
                            }
                        </>
                    }

                    <MultipleCheckbox
                        id='massimale'
                        label='Quali sono le coperture per te più importanti per vivere in serenità il tuo viaggio?'
                        value={this.props.tipo_copertura}
                        options={this.props.tipo_coperture}
                        error={this.props.tipo_coperturaError}
                        callBack={this.props.updateTipo_coperturaCallBack}
                        isMultiple={true}
                    />
                </div>

                <NoMotorPrivacy 
                    id='noMotorPrivacy'
                    basePrivacy={this.props.noMotorPrivacy}
                    isLogged={this.props.user !== undefined}
                    callback={this.props.updateNoMotorPrivacyCallBack}
                    error={this.props.noMotorPrivacyError}
                />
            </>
        )
    }

    private validateInizioViaggio () {
        return !isNotValidDataInzioViaggio(this.props.data_inizio, this.props.data_fine)
    }
    private validateFineViaggio () {
        return !isNotValidDataFineViaggio(this.props.data_inizio, this.props.data_fine)
    }
    private validateMaggiorenne () {
        return this.props.eta === undefined || (
            Number(this.props.eta) >= 18 && Number(this.props.eta) <= 99
        )
    }

    private updateEtaPartecipanti (e: FormEvent<HTMLInputElement>) {
        if (e !== undefined && e.currentTarget !== undefined ) {
            /*
                l'età dei partecipanti sarà rappresentata come un stringa 
                
                id0:valore0;id1:valore1;id2:valore2;

                quindi   1:18;2:50;3:80;

                indica che il partecipante 1 ha 18 anni
                indica che il partecipante 2 ha 50 anni
                indica che il partecipante 3 ha 80 anni
            */
            const value = e.currentTarget.value
            const id = e.currentTarget.id

            const regex = new RegExp(`${id}:\\d{1,};`, 'gi');

            let newval = undefined

            if ( !isEmpty( this.props.eta_partecipanti ) ) {
                // gestisco la rimozione
                newval = this.props.eta_partecipanti?.replaceAll(regex, '')

                // gestisco l'aggiunta
                if ( !isNaN( Number(value) ) ) {
                    newval = newval + id + ':' + value + ';'
                }
                
            } 
            else if ( !isNaN( Number(value) ) ) {
                newval = id + ':' + value + ';'
            }
            
            this.props.updateEta_partecipantiCallBack( newval )
        }
    }

    private updateDataFine (val: string | undefined) {
        this.setState({
            data_fine_start: moment(val, 'YYYY-MM-DD').add(1, 'day'),
            data_fine_end: moment(val, 'YYYY-MM-DD').add(1, 'months')
        }, () => {
            let ref = this.dataFineRef.current?.children[1]

            // fix -- react non cambi gli attributi min e max al cambimento di stato....
            if (ref && ref !== null) {
                ref.setAttribute(
                    'min', 
                    moment(val, 'YYYY-MM-DD').add(1, 'day').format(DATE_FORMAT)
                )
                ref.setAttribute(
                    'max', 
                    moment(val, 'YYYY-MM-DD').add(1, 'months').format(DATE_FORMAT)
                )
            }

            this.props.updateData_inizioCallBack (val)

            if (
                this.props.data_fine !== undefined && val !== undefined &&
                moment(val, 'YYYY-MM-DD').isSameOrAfter( moment(this.props.data_fine, 'YYYY-MM-DD') )
            ) {
                this.props.updateData_fineCallBack (undefined)
            } 
        })
    }
}

export default TravelStep2